import Immutable from 'seamless-immutable'
import {isEmptyObj} from 'utils/common'
import {
  ORDERS,
  ORDER_UPDATE,
  ORDER_HISTORY_LOADED_ALL,
  TRADE_HISTORY_LOADED_ALL,
  TRANSACTION_HISTORY_LOADED_ALL
} from 'actions'

const NEW = 'NEW'
const PARTIALLY_FILLED = 'PARTIALLY_FILLED'
const CANCELED = 'CANCELED'
const FILLED = 'FILLED'
const EXPIRED = 'EXPIRED'

const reducer = (
  state = Immutable({
    openOrders: {},
    orderHistories: {},
    orderHistoriesHasMore: false,
    tradeHistories: {},
    tradeHistoriesHasMore: false,
    transactionHistories: {},
    transactionHistoriesHasMore: false
  }),
  {type, response}
) => {
  if (type === ORDERS) {
    const res = Object.entries(response)[0]

    if (isEmptyObj(res[1])) {
      return state.set(res[0], res[1])
    }
    return response ? Immutable.merge(state || {}, response, {deep: true}) : state
  }
  if (type === ORDER_HISTORY_LOADED_ALL) {
    return state.set('orderHistoriesHasMore', response)
  }
  if (type === TRADE_HISTORY_LOADED_ALL) {
    return state.set('tradeHistoriesHasMore', response)
  }
  if (type === TRANSACTION_HISTORY_LOADED_ALL) {
    return state.set('transactionHistoriesHasMore', response)
  }
  if (type === ORDER_UPDATE) {
    const {status, orderId: rawOrderId} = response
    const orderId = String(rawOrderId)
    switch (status) {
    case NEW:
    case PARTIALLY_FILLED:
      return state.setIn(
        ['openOrders', String(orderId)],
        Immutable.merge(state?.openOrders?.[orderId] || {}, response)
      )
    case CANCELED:
    case FILLED:
    case EXPIRED:
      return state
      .updateIn(['openOrders'], d => d.without(orderId))
      .setIn(
        ['orderHistories', orderId],
        Immutable.merge(state?.orderHistory?.[orderId] || {}, response)
      )
    default:
      return state
    }
  }
  return state
}

export default reducer
